// ** React Imports
import React from 'react'

// ** MUI Imports
import { Button, Grid, Typography } from '@mui/material'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Util Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'
import { 
    initialOrdersWidgetData, 
    C2PWidgetConfig, 
    initialC2PConversionWidgetData} from 'src/assets/AnalyticsConfig'
import { useMerchant } from 'src/lib/contexts/MerchantContext'
import { setMerchantAttributes } from 'src/lib/core/api-methods'
import { useLoader } from 'src/lib/contexts/LoaderContext'

const C2PConversionDataWidget: React.FC<WidgetType> = ({ 
    value,
    isLoading
}) => {

    const { merchant, setMerchantData } = useMerchant();
    const { setLoaderProperties } = useLoader();
    const defaultValue = initialC2PConversionWidgetData?.data?.widgetData;
    const c2pEnabled = merchant?.attributes?.addressConfig?.c2pConfig?.isEnabled;

    const toggleC2PDiscount = async () => {
        setLoaderProperties({ isLoaderVisible: true });
        const modifiedAttributes = {
            attributes: {
                c2p: {
                    enabled: !merchant?.attributes?.addressConfig?.c2pConfig?.isEnabled,
                    expiry: merchant?.attributes?.addressConfig?.c2pConfig?.activePeriod
                }
            }
        } 
        const merchantResponse: any = await setMerchantAttributes(modifiedAttributes);
        setMerchantData(merchantResponse?.data);
        setLoaderProperties({ isLoaderVisible: false });
    }

    const fontProperties = [{
        fontSize: 28,
        fontWeight: 600,
        fontColor: "#4D4D4D",
        lineHeight: '36px'
    },
    {
        fontSize: 20,
        fontWeight: 500,
        fontColor: "#4D4D4D",
        lineHeight: '24px'
    },
    {
        fontSize: 20,
        fontWeight: 500,
        fontColor: "#4D4D4D",
        lineHeight: '24px'
    }]

    return (
        <>
            <Grid container spacing={4} width={"100%"}>
                {(value ?? defaultValue)?.map((pointValue: any, index: number) => {
                    return (
                        <Grid item display={"flex"} xs={C2PWidgetConfig?.[index]?.xs} flexGrow={1} key={`${index}`}>
                            <AnalyticsDataWidget
                                removeInnerPadding
                                widgetType={C2PWidgetConfig?.[index]?.widgetType} 
                                valueType={C2PWidgetConfig?.[index]?.valueType} 
                                description={C2PWidgetConfig?.[index]?.description}
                                widgetWidth={"100%"}
                                fontProperties={fontProperties[index]}
                                value={pointValue?.x ?? "0"}
                                isLoading={isLoading}
                                hideBorders
                                cardVariant='outlined'
                            />
                        </Grid>
                    )
                })}
            
            </Grid> 
            <div 
                style={{
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <Typography variant='subtitle2'>
                    {`Conversion discount is ${c2pEnabled ? "enabled" : "disabled"}.`}
                </Typography>
                <Button variant={"text"} onClick={toggleC2PDiscount}>
                    <span className='decoration-2 decoration-gray-200 underline underline-offset-2' >{ c2pEnabled ? "Disable" : "Enable" }</span>
                </Button>
            </div>
        </>
  )
}

export default C2PConversionDataWidget

            